<template>
  <router-view />

  <div class="attribution">
    Challenge by
    <a href="https://www.frontendmentor.io?ref=challenge" target="_blank"
      >Frontend Mentor</a
    >. Coded by <a href="https://github.com/GemTay">Gemma Taylor</a>.
  </div>
</template>
